import { USER_ROLES } from '../Shipment/components/QuoteCard/constants';

export const getSelectDateWithCurrentTime = (selectDate) => {
  const currentDate = new Date();

  return selectDate.set({
    hours: currentDate.getHours(),
    minute: currentDate.getMinutes(),
    second: currentDate.getSeconds(),
  });
};

export const isFutureDate = (currentDate, nextDate) => nextDate.valueOf() > currentDate.valueOf();

export const mapCollaboratorsSearchResult = (acc, curr) => {
  // exclude third party users
  const availableRoles = Object.values(USER_ROLES);
  if (availableRoles.includes(curr.roleDescription)) {
    return [
      ...acc,
      {
        emails: curr?.emailAddress,
        group: curr?.type,
        notificationsEnabled: curr?.notificationsEnabled === undefined ? true : curr?.notificationsEnabled,
        role: curr?.roleDescription,
        userId: curr?.id,
        userName: [curr?.firstName, curr?.lastName].join(' '),
      },
    ];
  }

  return acc;
};

export const normalizeKey = (key) =>
  key
    ?.toString()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');

/**
 * Extracts and normalizes form values, then maps them to the API-requested routing param keys.
 */
export const parseRoutingParams = (settingsData, forms) => {
  const requiredKeys = JSON.parse(settingsData.IsRoutingGuideEnabled);

  const allValues = Object.values(forms).reduce((acc, form) => {
    return { ...acc, ...form.getFieldsValue(true) };
  }, {});

  // Flatten nested port fields
  if (allValues.ports?.[0]) {
    Object.assign(allValues, allValues.ports[0]);
  }

  const normalizedFormValues = Object.keys(allValues).reduce((acc, key) => {
    acc[normalizeKey(key)] = allValues[key];
    return acc;
  }, {});

  return requiredKeys.reduce((acc, apiFieldName) => {
    const value = normalizedFormValues[normalizeKey(apiFieldName)];
    if (value !== undefined && value !== null) {
      acc[apiFieldName] = value;
    }
    return acc;
  }, {});
};

export const isRoutingParamsComplete = (requiredKeys, routingParams) =>
  requiredKeys.every((key) => {
    const val = routingParams?.[key];
    return val !== undefined && val !== null && val !== '';
  });

export const hasRoutingParamsChanged = (requiredKeys, prev, current) =>
  !prev || requiredKeys.some((key) => prev[key] !== current?.[key]);
